import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from "app/store";
import useAppUtil from './useAppUtil';

/**
 * LogoutListener component
 *
 * - Watches the Redux `auth` slice for the `logoutRequested` flag.
 * - When `logoutRequested` is set to `true` (by customBaseQuery or other flows),
 *   it calls `logoutHandler`
 */
const LogoutListner: React.FC = () => {
    const { logoutHandler } = useAppUtil();
    const { logoutRequested } = useSelector((state: RootState) => state.auth);
    useEffect(() => {
        if (logoutRequested === true) {
            logoutHandler({ clearAuthTokenCookies: false, showLoginModal: true });
        }
    }, [logoutRequested, logoutHandler]);

    return null;
};

export default LogoutListner;
